var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "p-05 font-small-3 text-bold-700",
      staticStyle: { "margin-top": "1px" },
    },
    [
      _c("div", { staticClass: "dropdown" }, [
        _c(
          "a",
          {
            staticClass: "dropdown-toggle",
            attrs: {
              id: "socialShareButton",
              "data-toggle": "dropdown",
              "aria-haspopup": "true",
              "aria-expanded": "false",
            },
          },
          [
            _c("i", { staticClass: "fa fa-share-alt" }),
            _vm._v(" " + _vm._s(_vm.__("globals.share")) + "\n        "),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "dropdown-menu mb-0 pb-0",
            attrs: { "aria-labelledby": "socialShareButton" },
          },
          [
            _c("ul", [
              _c(
                "li",
                {
                  staticClass: "mt-05 mb-1 d-inline-block",
                  staticStyle: { "margin-left": "-20px" },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "social-button",
                      staticStyle: { color: "#3b5998" },
                      attrs: { href: this.social.facebook },
                    },
                    [
                      _c("span", {
                        staticClass: "fa fa-facebook",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.__("globals.facebook")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "mb-1 d-inline-block",
                  staticStyle: { "margin-left": "-20px" },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "social-button",
                      attrs: { href: this.social.twitter },
                    },
                    [
                      _c("span", {
                        staticClass: "fa fa-twitter",
                        staticStyle: { color: "#55acee" },
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.__("globals.twitter")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "mb-1 d-inline-block",
                  staticStyle: { "margin-left": "-20px" },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "social-button",
                      attrs: { href: this.social.linkedin },
                    },
                    [
                      _c("span", {
                        staticClass: "fa fa-linkedin",
                        staticStyle: { color: "#007bb6" },
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.__("globals.linkedin")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.id !== ""
                ? _c(
                    "li",
                    {
                      staticClass: "d-inline-block",
                      staticStyle: { "margin-left": "-20px" },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "social-button",
                          attrs: {
                            href: "#",
                            "data-toggle": "modal",
                            "data-target": "#shareModal" + _vm.id,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.shareNewsfeed.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "fa fa-share-alt",
                            staticStyle: { color: "#007bb6" },
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.__("globals.newsfeed")) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }